var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAimeHeroLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 357,
    viewBox: "0 0 321 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.1162,
    width: 200,
    height: 200,
    rx: 45.4545,
    fill: "url(#paint0_linear_229_5978)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.337 148.33C217.337 151.381 216.367 153.947 214.425 156.027C212.483 157.969 209.987 158.94 206.935 158.94C204.023 158.94 201.526 157.969 199.446 156.027C197.504 153.947 196.533 151.381 196.533 148.33V59.288C196.533 56.2368 197.504 53.7403 199.446 51.7985C201.526 49.7181 204.023 48.6779 206.935 48.6779C209.987 48.6779 212.483 49.7181 214.425 51.7985C216.367 53.7403 217.337 56.2368 217.337 59.288V148.33Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.494 84.468C110.669 82.2161 104.843 84.2944 103.441 89.431C100.792 99.1346 100.758 109.429 103.432 119.246C106.955 132.184 114.953 143.453 126.002 151.049C137.051 158.646 150.437 162.078 163.778 160.735C177.119 159.393 189.552 153.363 198.866 143.717C208.181 134.071 213.773 121.435 214.648 108.055C215.523 94.6746 211.625 81.4176 203.647 70.6406C195.669 59.8637 184.127 52.2651 171.075 49.1959C161.17 46.867 150.883 47.2605 141.278 50.2474C136.194 51.8285 134.32 57.7232 136.739 62.4664C139.159 67.2096 144.972 68.9534 150.175 67.8241C155.574 66.6523 161.206 66.6831 166.661 67.9659C175.272 69.9907 182.886 75.0036 188.15 82.1133C193.413 89.2231 195.984 97.9689 195.407 106.796C194.83 115.623 191.141 123.959 184.996 130.323C178.851 136.686 170.649 140.664 161.847 141.55C153.046 142.436 144.215 140.172 136.926 135.16C129.637 130.148 124.361 122.714 122.036 114.179C120.563 108.772 120.336 103.145 121.318 97.7083C122.265 92.4686 120.319 86.7199 115.494 84.468Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.792 104.356C169.792 110.811 164.559 116.043 158.105 116.043C151.65 116.043 146.417 110.811 146.417 104.356C146.417 97.9014 151.65 92.6689 158.105 92.6689C164.559 92.6689 169.792 97.9014 169.792 104.356Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.383 65.0747C105.974 62.752 105.904 58.9161 108.227 56.5071C110.549 54.098 114.385 54.028 116.794 56.3507L156.254 94.3953C158.663 96.7179 158.733 100.554 156.41 102.963C154.087 105.372 150.252 105.442 147.843 103.119L108.383 65.0747Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5592 48.8593C89.0055 49.3366 88.0091 52.4635 89.8159 54.3302L101.452 66.3524C102.233 67.159 103.374 67.5072 104.472 67.2738L113.628 65.3281C114.906 65.2076 116.102 64.3468 116.482 62.9198L119.017 53.3942C119.298 52.338 119.031 51.2111 118.306 50.3933L107.389 38.0828C105.688 36.1652 102.542 36.87 101.822 39.3298L99.465 47.3819L91.5592 48.8593Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.764 348.303C117.764 350.386 117.102 352.138 115.776 353.558C114.451 354.883 112.747 355.546 110.664 355.546C108.676 355.546 106.972 354.883 105.552 353.558C104.226 352.138 103.564 350.386 103.564 348.303V287.525C103.564 285.442 104.226 283.738 105.552 282.413C106.972 280.993 108.676 280.283 110.664 280.283C112.747 280.283 114.451 280.993 115.776 282.413C117.102 283.738 117.764 285.442 117.764 287.525V348.303Z",
    fill: "url(#paint1_linear_229_5978)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.812 256C146.949 256 148.132 256.284 149.363 256.852C150.593 257.42 151.54 258.225 152.203 259.266L188.272 314.222L182.166 313.938L218.945 259.266C220.46 257.089 222.401 256 224.767 256C226.661 256 228.318 256.71 229.738 258.13C231.252 259.455 232.01 261.16 232.01 263.242V348.303C232.01 350.386 231.347 352.138 230.022 353.558C228.696 354.883 226.945 355.546 224.767 355.546C222.495 355.546 220.649 354.883 219.229 353.558C217.904 352.138 217.241 350.386 217.241 348.303V276.307L221.785 277.301L190.544 324.873C189.881 325.725 189.029 326.482 187.988 327.145C186.947 327.713 185.858 327.949 184.722 327.855C183.681 327.949 182.592 327.713 181.456 327.145C180.414 326.482 179.562 325.725 178.9 324.873L148.795 278.011L152.203 272.331V348.303C152.203 350.386 151.54 352.138 150.215 353.558C148.984 354.883 147.327 355.546 145.244 355.546C143.256 355.546 141.6 354.883 140.274 353.558C139.044 352.138 138.428 350.386 138.428 348.303V263.242C138.428 261.254 139.138 259.55 140.558 258.13C142.073 256.71 143.824 256 145.812 256Z",
    fill: "url(#paint2_linear_229_5978)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M288.424 356.966C280.566 356.966 273.75 355.356 267.975 352.138C262.2 348.824 257.703 344.327 254.484 338.647C251.36 332.872 249.798 326.293 249.798 318.908C249.798 310.577 251.455 303.477 254.768 297.608C258.176 291.643 262.579 287.099 267.975 283.975C273.371 280.756 279.099 279.147 285.157 279.147C289.796 279.147 294.199 280.094 298.364 281.987C302.529 283.786 306.222 286.342 309.44 289.655C312.754 292.874 315.357 296.708 317.251 301.158C319.144 305.513 320.138 310.293 320.233 315.5C320.138 317.394 319.381 318.956 317.961 320.186C316.541 321.417 314.884 322.032 312.991 322.032H257.75L254.342 309.962H307.736L305.038 312.518V308.968C304.849 305.655 303.76 302.767 301.772 300.306C299.784 297.75 297.323 295.809 294.388 294.483C291.453 293.063 288.376 292.353 285.157 292.353C282.317 292.353 279.572 292.827 276.921 293.773C274.365 294.625 272.046 296.046 269.963 298.034C267.975 300.022 266.365 302.672 265.135 305.986C263.999 309.205 263.431 313.228 263.431 318.056C263.431 323.263 264.519 327.807 266.697 331.689C268.874 335.57 271.809 338.6 275.501 340.777C279.193 342.86 283.264 343.901 287.714 343.901C291.216 343.901 294.104 343.57 296.376 342.907C298.648 342.15 300.541 341.251 302.056 340.209C303.571 339.168 304.896 338.174 306.032 337.227C307.452 336.375 308.872 335.949 310.292 335.949C311.996 335.949 313.417 336.564 314.553 337.795C315.689 338.931 316.257 340.304 316.257 341.913C316.257 343.996 315.215 345.889 313.133 347.593C310.576 350.055 307.026 352.232 302.482 354.126C298.033 356.019 293.346 356.966 288.424 356.966Z",
    fill: "url(#paint3_linear_229_5978)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6721 348.304C87.6721 350.387 87.0094 352.138 85.6841 353.558C84.3587 354.883 82.6546 355.546 80.5719 355.546C78.5838 355.546 76.8797 354.883 75.4597 353.558C74.1343 352.138 73.4716 350.387 73.4716 348.304V287.526C73.4716 285.443 74.1343 283.739 75.4597 282.413C76.8797 280.993 78.5838 280.283 80.5719 280.283C82.6546 280.283 84.3587 280.993 85.6841 282.413C87.0094 283.739 87.6721 285.443 87.6721 287.526V348.304Z",
    fill: "url(#paint4_linear_229_5978)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.174 256.622C109.512 255.125 105.314 256.874 103.989 260.601C103.896 260.86 103.804 261.12 103.713 261.381C102.408 265.114 104.579 269.11 108.369 270.242L108.646 270.324C112.283 271.41 116.096 269.335 117.358 265.755C118.621 262.176 116.954 258.168 113.441 256.731L113.174 256.622Z",
    fill: "url(#paint5_linear_229_5978)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1556 304.713C14.8622 303.176 10.8857 304.595 9.92848 308.101C8.12011 314.724 8.09719 321.751 9.9222 328.452C12.3274 337.283 17.7862 344.975 25.3283 350.16C32.8703 355.345 42.0068 357.688 51.1134 356.772C60.2199 355.855 68.7065 351.739 75.0642 345.155C81.4219 338.571 85.2388 329.946 85.8363 320.813C86.4337 311.68 83.7731 302.631 78.3273 295.275C72.8816 287.919 65.0036 282.732 56.094 280.637C49.3335 279.047 42.3115 279.316 35.7553 281.355C32.2848 282.434 31.006 286.457 32.6573 289.695C34.3086 292.933 38.2766 294.123 41.8284 293.352C45.5135 292.552 49.3576 292.573 53.0814 293.449C58.9592 294.831 64.1564 298.253 67.7491 303.106C71.3417 307.959 73.097 313.928 72.7028 319.954C72.3087 325.979 69.7906 331.669 65.5963 336.013C61.402 340.356 55.8033 343.072 49.7956 343.676C43.7878 344.281 37.7604 342.735 32.7847 339.314C27.8091 335.894 24.2078 330.819 22.6211 324.993C21.6159 321.302 21.4605 317.461 22.131 313.751C22.7772 310.174 21.449 306.25 18.1556 304.713Z",
    fill: "url(#paint6_linear_229_5978)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2182 318.288C55.2182 322.694 51.6466 326.266 47.2408 326.266C42.835 326.266 39.2634 322.694 39.2634 318.288C39.2634 313.882 42.835 310.311 47.2408 310.311C51.6466 310.311 55.2182 313.882 55.2182 318.288Z",
    fill: "url(#paint7_linear_229_5978)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3019 291.475C11.6575 289.89 11.6097 287.272 13.1952 285.627C14.7806 283.983 17.3988 283.935 19.0432 285.521L45.9775 311.489C47.6219 313.075 47.6697 315.693 46.0843 317.337C44.4988 318.982 41.8806 319.029 40.2362 317.444L13.3019 291.475Z",
    fill: "url(#paint8_linear_229_5978)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81819 280.407C0.0750893 280.733 -0.605053 282.867 0.628225 284.141L8.57081 292.348C9.10372 292.898 9.88245 293.136 10.6319 292.977L16.882 291.648C17.7544 291.566 18.5705 290.979 18.8297 290.005L20.5602 283.503C20.7522 282.782 20.5699 282.012 20.0748 281.454L12.6232 273.051C11.4625 271.742 9.3148 272.223 8.82332 273.902L7.21457 279.399L1.81819 280.407Z",
    fill: "url(#paint9_linear_229_5978)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_229_5978",
    x1: 160.116,
    y1: 0,
    x2: 160.116,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_229_5978",
    x1: 10.2863,
    y1: 321.61,
    x2: 320.233,
    y2: 319.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_229_5978",
    x1: 10.2863,
    y1: 321.61,
    x2: 320.233,
    y2: 319.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_229_5978",
    x1: 10.2863,
    y1: 321.61,
    x2: 320.233,
    y2: 319.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_229_5978",
    x1: 10.2863,
    y1: 321.61,
    x2: 320.233,
    y2: 319.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_229_5978",
    x1: 10.2863,
    y1: 321.61,
    x2: 320.233,
    y2: 319.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_229_5978",
    x1: 10.2863,
    y1: 321.61,
    x2: 320.233,
    y2: 319.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_229_5978",
    x1: 10.2863,
    y1: 321.61,
    x2: 320.233,
    y2: 319.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_229_5978",
    x1: 10.2863,
    y1: 321.61,
    x2: 320.233,
    y2: 319.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_229_5978",
    x1: 10.2863,
    y1: 321.61,
    x2: 320.233,
    y2: 319.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993327,
    stopColor: "#FF6F00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAimeHeroLogo);
export default __webpack_public_path__ + "static/media/aime-hero-logo.bc94128f8f3eb2250a18d519d5d66a4c.svg";
export { ForwardRef as ReactComponent };